import BaseError from './base-error'

class ParseError extends BaseError {
}

export default ParseError
